import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PaymentPlan } from "../../models/payment-plan/payment-plan.model";

@Component({
    selector: 'paid-plan-card',
    templateUrl: './paid-plan-card.component.html',
    styleUrls: ['./paid-plan-card.component.scss'],
    standalone: false
})
export class PaidPlanCardComponent {
    @Input() plans: PaymentPlan[] = [];
    @Input() inputSelectedPlan: PaymentPlan | null = null;
    @Input() platformFeePlan: PaymentPlan | null = null;
    @Output() emitSelectedPlan = new EventEmitter<PaymentPlan>();


    get sortedPlansByAmount() {
        return [...this.plans].sort(
            (a, b) => (a.amountPerMonth ?? Infinity) - (b.amountPerMonth ?? Infinity)
        );
    }

    selectPlan(plan: PaymentPlan) {
        console.log('selectPlan', plan);
        this.emitSelectedPlan.emit(plan);
    }
}